import { defineStore } from 'pinia'

export const useUserStore = defineStore({
  id: 'user',
  state: () => ({
    needAccessibility: false as boolean,
    firefoxUser: false as boolean
  }),
  getters: {
    accessibleNavigation(state) {
      return state.needAccessibility
    },
    isUsingFirefox(state) {
      return state.firefoxUser
    }
  },
  actions: {
    setNavigationHasAccessible() {
      this.needAccessibility = true
    },
    setIsUsingFirefox() {
      this.firefoxUser = navigator.userAgent.search('Firefox') !== -1
    }
  }
})
